.bam-stage-shared {

  .bal-stage {
    &.has-shape{
      section {
        @include desktop {
          margin-bottom: 66px;
        }
      }
    }
    section {
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding: 0 !important;
      max-width: unset;
    }
    .bal-stage-body {
      min-height: unset !important;
      & > * {
        max-width: unset !important;
      }
    }
  }

  .bam-stage-shared__wrapper {
    display: flex;
    flex-direction: column-reverse;
    height: auto;

    @include desktop {
      height: 688px;
      flex-direction: row;
      justify-content: flex-start;
    }

    @include from(1400px) {
      margin-left: calc(calc(100vw - 1304px)/ 2);   
    }

    @include from(1480px) {
      margin-left: calc(calc(100vw - 1396px)/ 2); 
    }

    .bam-stage-shared__content {

      @include desktop {
        display: flex;
        align-items: center;
        padding: 10rem 2rem 4rem 3rem;
        width: 41.667%; 
      }

      @include from(1400px) {
        padding: 10rem 2rem 4rem 0;
        max-width: 600px;
      }

      .bam-stage-shared__content-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 2rem 1rem 1.5rem 1rem;

        // ONLY SHARED STAGE: overwrite list icon position
        ul.is-bullet-check-circle {
          margin-left: 24px !important;
        }

        @include tablet {
          padding: 3.5rem 2.5rem 4rem 2.5rem;
        }

        @include desktop {
          padding: 0;
        }

        .bam-stage-shared__button-wrapper {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          margin-top: 1rem;

          @include tablet {
            margin-top: 1.5rem;
            justify-content: center;
          }

          @include desktop {
            justify-content: flex-start;
          }

          & bal-button,
          & bal-button a {
            width: 100%;

            @include tablet {
              width: auto
            }
          }
        }
      }
    }

    .bam-stage-shared__image {
      position: relative;
      width: 100%;

      @include tablet-only {
        width: 100vw;
        height: auto;
      }

      @include desktop {
        height: 100%;
        max-width: 1223px;
      }

      bam-image {
        height: 100% !important;

        @include desktop {
          left: 0;
          width: max-content;
        }

        .bam-image__imageContainer,
        figure,
        picture{
          height: 100%;
        }

        img {
          height: 100% !important;
          object-fit: cover;
        }
      }
  /* !!! The shape for the 'Shared-Stage' is NOT controlled by the bal-stage props but set separatly
  *  to make the alignment with the image work.
  *  Therefore it has to be styled here.
  */
      bal-shape {
        position: absolute;
        right: 1rem;
        bottom: -22px;

        @include tablet {
          right: 2.5rem;
          bottom: -40px;
        }

        @include desktop {
          right: 3rem;
          bottom: -66px;
        }
        
        @include from(1440px) {
          position: fixed;
          right: 3rem;
          bottom: -66px;
        }

        @include from(1496px) {
          left: calc(50% + 502px);
          right: unset
        }
      }
    }
  }

  &--is-small {
    .bam-stage-shared__wrapper {

      @include desktop {
        height: 576px
      }

      .bam-stage-shared__image {
        @include desktop {
          max-width: 1024px;
        }
      }
    }
  }
}
